import React from 'react';
import { motion } from 'framer-motion';
const features = ['300+ pagine', '60+ lezioni pronte', 'Tecnica', 'Progressione', 'Pianificazione', 'Sbarra', 'Centro', 'Coreografie', 'Mobilità', 'Prevenzione', 'Fidelizzazione', 'Biomeccanica', 'Musica', 'Metodologia'];
const contents = ['Esercizi alla Sbarra', 'Petit Allegro', 'Grand Allegro', 'Adagio', 'Variazioni Coreografiche', 'Programmi 4/8/12 Settimane', 'Gestione Gruppi Misti', 'Valutazione Allieve', 'Fidelizzazione Professionale', 'Musica e Atmosfera'];
export function SystemOverview() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-201">
        <div className="text-center mb-10 md:mb-16" data-id="element-202">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-charcoal mb-4 md:mb-6" data-id="element-203">
            IL SISTEMA N°1 PER INSEGNANTI DI BALLET IN ITALIA
          </h2>
          <p className="text-lg md:text-xl text-ballet-600 font-medium mb-2 md:mb-4" data-id="element-204">
            Sistema completo · 7 Volumi + 5 Bonus · Tutti i livelli · Tutto
            risolto.
          </p>
          <p className="text-sm md:text-base text-gray-600" data-id="element-205">
            Funziona da oggi nella tua sala, studio o accademia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-206">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-ballet-50 p-6 md:p-8 rounded-3xl border border-ballet-100 transition-all duration-300 hover:shadow-md" data-id="element-207">
            <h3 className="text-xl md:text-2xl font-bold text-charcoal mb-4 md:mb-6 flex items-center" data-id="element-208">
              <span className="text-xl md:text-2xl mr-2 md:mr-3" data-id="element-209">✨</span> Cosa
              include
            </h3>
            <div className="flex flex-wrap gap-2 md:gap-3" data-id="element-210">
              {features.map((feature, idx) => <span key={idx} className="inline-flex items-center px-2.5 py-1 md:px-3 md:py-1.5 rounded-full bg-white text-ballet-800 text-xs md:text-sm font-medium shadow-sm border border-ballet-100 transition-colors hover:bg-ballet-100" data-id="element-211">
                  <span className="text-ballet-400 mr-1 md:mr-1.5" data-id="element-212">✔️</span>{' '}
                  {feature}
                </span>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-charcoal p-6 md:p-8 rounded-3xl text-white transition-all duration-300 hover:shadow-lg hover:shadow-charcoal/20" data-id="element-213">
            <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 flex items-center text-ballet-200" data-id="element-214">
              <span className="text-xl md:text-2xl mr-2 md:mr-3" data-id="element-215">📚</span>{' '}
              Contenuti
            </h3>
            <ul className="space-y-2 md:space-y-3" data-id="element-216">
              {contents.map((content, idx) => <li key={idx} className="flex items-center text-sm md:text-base text-gray-300 transition-colors hover:text-white" data-id="element-217">
                  <div className="w-1.5 h-1.5 rounded-full bg-ballet-400 mr-2 md:mr-3" data-id="element-218"></div>
                  {content}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}